import Model from 'src/app/common/model';
import FeedTypeModel from './feedType.model';
import SpeciesTypeModel from './speciesType.model';
import CustomerPondModel from './customerPond.model';
import PondCultureModel from './pondCulture.model';
import ItemMasterModel from './itemMaster.model';
import FeedNameModel from './feedName.model';
import FeedRateProgrammeModel from './feedRateProgramme.model';
import FeedRateSettingModel from './feedRateSetting.model';
import FRSFeedTypeModel from './frsFeedType.model';

export default class FeedRateModel extends Model {
  FeedType: FeedTypeModel;
  speciesType: SpeciesTypeModel; // AQU
  pond: CustomerPondModel; // AQU
  pondCulture: PondCultureModel; // AQU
  ItemMaster: ItemMasterModel; // MMS
  feedName: FeedNameModel;
  feedRateProgramme: FeedRateProgrammeModel;
  feedRateSettings: FeedRateSettingModel;
  frsFeedType: FRSFeedTypeModel;
  feedname_id?: number;
  feed_rate_programme_id: number;
  person_id?: string;
  section_id?: number;
  business_id?: string;
  farm_site_id?: string;
  pond_id: number;
  pond_culture_id: number;
  species_type_id: number;
  default: boolean;
  projectedDOC: number;
  projectedABW: number;
  actualABW: number;
  actualCumulativeFeed: number;
  availableNumber: number;
  projectedCumulativeFeed: number;

  constructor() {
    super();
  }
}
